const FIRST = "orbit_attr_first", LAST = "orbit_attr_last";
const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];

export function captureAttribution() {
  try {
    const p = new URLSearchParams(window.location.search);
    const hasParams = KEYS.some((k) => p.get(k));
    const ref = document.referrer || "";
    if (!hasParams && !ref && localStorage.getItem(LAST)) return;
    const touch = Object.fromEntries(KEYS.map((k) => [k, p.get(k) || ""]));
    touch.landing_page = window.location.pathname;
    touch.referrer = ref.slice(0, 500);
    touch.ts = new Date().toISOString();
    if (!localStorage.getItem(FIRST)) localStorage.setItem(FIRST, JSON.stringify(touch));
    localStorage.setItem(LAST, JSON.stringify(touch));
  } catch { /* storage unavailable */ }
}

export function getAttribution() {
  try {
    return { first_touch: JSON.parse(localStorage.getItem(FIRST) || "null"), last_touch: JSON.parse(localStorage.getItem(LAST) || "null") };
  } catch { return { first_touch: null, last_touch: null }; }
}

export function idempotencyKey(ns) {
  const k = `orbit_idem_${ns}`;
  let v = sessionStorage.getItem(k);
  if (!v) { v = (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now()).replace(/-/g, ""); sessionStorage.setItem(k, v); }
  return v;
}

export function resetIdempotency(ns) { sessionStorage.removeItem(`orbit_idem_${ns}`); }
